module.exports = __webpack_public_path__ + "static/img/数据总览字.7d03292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crop_distribution/数据总览字.png
// module id = eQVS
// module chunks = 1